module.exports = __webpack_public_path__ + "static/media/img-error.33aad3cf.svg";